import { Route } from 'react-router-dom';
import { home } from 'routes/config';

import CallLogs from 'containers/Business/Agent/CallLogs';
import CallLogForm from 'containers/Business/Agent/CallLogs/components/CallLogForm';

export const callLogsRoutes = (
  <Route path={home.callLogs} element={<CallLogs />}>
    <Route path=':id' element={<CallLogForm />} />
  </Route>
);
